// extracted by mini-css-extract-plugin
export default {"PharmacyPanelContainer":"funRfIVN","PharmacyPageCenterText":"oISBGm80"};